import React, { useState, useEffect, useContext } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import { t } from "i18next";
import {
  Calendar,
  Checkbox,
  PrimaryButton,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from "@fluentui/react";
import Moment from "moment";
import userContext from "../../context/users/UserContext";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import toastContext from "../../context/toast/ToastContext";
import {
  deleteReportTemplateApi,
  getReportTemplatesListByTab,
} from "../../service/MasterService";
import { CustomReportTemplateColumn, reportTemplateInitialFilterObj } from "./helper/helper";
import { useNavigate } from "react-router";
import ReportTemplateContent from "./ReportTemplateContent";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { searchStyle } from "../IssuesAndTroubleshooting/helper/helper";
import { checkboxFilterStyle } from "../StudyList/helpers/ConstantStyles";
import { USERTYPES } from "../../constants/Constants";

const CustomReportTemplate = ({ modalityList, radiologistList,tabId }) => {
  const { roles } = useContext(userContext);
  const [selectedRow, setSelectedRow] = useState(0);
  const [rowDetails, setRowDetails] = useState("");
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [auditLogList, setAuditLogList] = useState([]);
  const navigate = useNavigate();
  const [activeDataQuery, setActiveDataQuery] = useState([]);
  const [userData, setUserData] = useState([]);

  const [deletedId, setDeletedId] = useState();
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);

  const [listForFilter, setListForFilters] = useState(reportTemplateInitialFilterObj);
  const [storeListForFilter, setStoreListForFilters] = useState(reportTemplateInitialFilterObj);
  const [list, setList] = useState({modalityList: modalityList, clientList: null, radiologistList: radiologistList});
  const [storeList, setStoreList] = useState({modalityList: modalityList, clientList: null, radiologistList: radiologistList});

  useEffect(()=>{
    console.log("--Child--",modalityList);
  },[])

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });

  const fetchData = async (options) => {
    let page = options.page;
    let pageSize = options.pageSize;
    console.log("--- Fetching Data ----", options);
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    let body = {
      paginationDto: {
        pageNumber: page,
        pageSize: 10,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      modalityIds: Object.values(listForFilter?.modalityIds).map(
        (item) => item.value
      ),
      radiologistIds: Object.values(listForFilter?.radiologistIds).map(
        (item) => item.value
      )
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getReportTemplatesListByTab(tabId, body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log("---- Response ----", response);
        const results = response.data.data.reportTemplatesList;
        setRowDetails(results[0].report);
        setUserData(response.data.data.reportTemplatesByUserId);
        // setUserActionMenuList(response.data.data.userActionMenu);
        // setAuditLogList(results);

        const pageSize = 10;
        const totalElement = response.data.data.total;
        data = results;
        pageCount = Math.ceil(totalElement / pageSize);
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
          userData: response.data.data.reportTemplatesByUserId,
          clientData: response.data.data.clientReportTemplatesByUserId,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
          userData: response.data.data.reportTemplatesByUserId,
          clientData: response.data.data.clientReportTemplatesByUserId,
        };
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = (cell) => {
    let row = cell.row;
    setSelectedRow(row.index);
    setRowDetails(row.original.report);
  };

  const deleteConfirmModal = (reportTemplateId) => {
    setDeletedId(reportTemplateId);
    setShowDeleteConfirmModal(true);
  };

  const handleEdit = (reportTemplateId) => {
    navigate("/report/edit/template/" + tabId + "?id=" + reportTemplateId, {});
  };

  const columns = CustomReportTemplateColumn(
    roles[0],
    userData,
    handleEdit,
    deleteConfirmModal
  );

  useEffect(() => {
    if (activeDataQuery != undefined && activeDataQuery.data != undefined) {
      setRowDetails(activeDataQuery?.data?.rows[0]?.report);
      setUserData(activeDataQuery?.data.userData);
    }
  }, [activeDataQuery]);

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            navigate("/report/add/template/" + tabId);
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            text={"Create new template"}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
          />
        </div>
      ),
    },
  ];

  const deleteReportTemplate = async () => {
    let payload = { reportTemplateId: deletedId };
    let response = await deleteReportTemplateApi(payload);
    if (response.data.result === "SUCCESS") {
      showToastv2("success", response.data.message);
    } else {
      showToastv2("error", response.data.message);
    }
    setShowDeleteConfirmModal(false);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
    setSelectedRow(0);
  };

  const handleApplyClick = (filterValue) => {
    //TODO
    if (filterValue != undefined) filterValue = filterValue.trim();
    const transformedArray = Object.keys(listForFilter)
                  .flatMap(key => {
                    if (Array.isArray(listForFilter[key])) {
                      return listForFilter[key].filter(item => item !== null && item !== undefined);
                    }
                    return [];
                  });
    console.log("--- Transformed Array ---", listForFilter);
    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const filterList = (searchInput) => {
    //TODO
  };

  const handleClearFilter = () => {
    //TODO
    setDisplayListAppliedFilter([]);
    setListForFilters(reportTemplateInitialFilterObj);
    setStoreListForFilters(reportTemplateInitialFilterObj);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = "";
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    //TODO
    const updatedFilterList = {};
    for (const key in listForFilter) {
      if (Array.isArray(listForFilter[key])) {
        updatedFilterList[key] = listForFilter[key].filter(item => item.label !== toBeRemoveObj.label);
      } else {
        updatedFilterList[key] = listForFilter[key];
      }
    }

    setListForFilters(updatedFilterList);
    setStoreListForFilters(updatedFilterList);

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  }

  const handlePopupClose = () => {
    console.log("--- Popup Close running ---")
    setList(storeList);
  }

  return (
    <>
      {showDeleteConfirmModal && (
        <ConfirmModal
          handleConfirm={deleteReportTemplate}
          handleNotConfirm={() => {
            setShowDeleteConfirmModal(!showDeleteConfirmModal);
          }}
          showConfirmModal={showDeleteConfirmModal}
          message={t("string-literals.delete-report-template")}
          title={t("confirm-message.confirm")}
          confirmButtonText={t("confirm-message.yes")}
        />
      )}
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        showSideBySide={true}
        tabHeaderPresent={true}
        paginationObj={paginationObj}
        placeholder={"Report Name"}
        uniqueKey={"CustomReport"}
        selectedRow={selectedRow}
        setActiveDataQuery={setActiveDataQuery}
        selectedRowComponent={<SelectedRowComponent rowDetails={rowDetails} />}
        constantFilterHeight={false}

        enhancedFilter={true}
        showSort={false}
        handleApplyClick={handleApplyClick}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        handlePopupClose={handlePopupClose}
        filterPopUpComponent={
          <FilterPopUpComponent
              setList={setList}
              list={list}
              storeList={storeList}
              listForFilter={listForFilter}
              setListForFilters={setListForFilters}
              roles = {roles}
          />
        }
        pointer={false}

      />
    </>
  );
};

export default CustomReportTemplate;

const SelectedRowComponent = ({ rowDetails }) => {
  return (
    <>
    {rowDetails != null && rowDetails != undefined && rowDetails?.length > 0 &&
      <div
        className="h100 w100"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="reportTemplateHtmlContent"
          dangerouslySetInnerHTML={{ __html: rowDetails }}
        ></div>
      </div>
      }
    </>
  );
};

export const FilterPopUpComponent = ({
  setList,
  list,
  storeList,
  listForFilter,
  setListForFilters,
  roles
}) => {

    const filterList = (searchInput,filterName) => {
      if (searchInput != null && searchInput != undefined)
        searchInput = searchInput.trim();
      let searchValue = searchInput.toLowerCase();
      let allTemp = storeList[filterName];
      if (searchValue != "") {  

        const filteredData = allTemp.filter((item) => {

          if(filterName == "radiologistList"){
            let name = item.firstName + " " + item.lastName;
            if(item.name != undefined){
              name = item.name;
            }
            return name.toLowerCase().includes(searchValue);
          }
          return item.name.toLowerCase().includes(searchValue);
        });
        setList(()=>{
          const newItem = {...list};
          newItem[filterName] = filteredData;
          return newItem;
       })
      } else {
        setList(()=>{
          const newItem = {...list};
          newItem[filterName] = storeList[filterName];
          return newItem;
       })
      }
    };

  const customToolTipClassName = {
    root: "audit-logs-user-action-text",
  };

  return (
    <div style={{ display: "flex" }}>
     <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">{t("navbar.modalities")}</span>
        <SearchBox
          placeholder="Search"
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            filterList(newValue,"modalityList");
          }}
        />
        <div
          className={`modal-scroll study-list-filter-section ${
            list?.modalityList?.length == 0 ? "no-result-container" : ""
          }`}
        >
          {list?.modalityList != null &&
            Array.from(list?.modalityList).map((itemValue) => {
              return (
                <Checkbox
                  key={itemValue.id}
                  label={itemValue.name}
                  name={itemValue.name}
                  styles={checkboxFilterStyle}
                  // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                  checked={listForFilter?.modalityIds?.some(
                    (item) => item.value === itemValue.id
                  )}
                  onChange={(e, data) => {
                    if (data) {
                      console.log("-- check --", [{
                        label: itemValue.name,
                        value: itemValue.id
                      }]);
                      setListForFilters({...listForFilter, modalityIds: [
                        ...listForFilter.modalityIds,
                        {
                        label: itemValue.name,
                        value: itemValue.id
                      }]});
                    } else {
                      console.log("-- uncheck --");
                      setListForFilters((currentListForFilters) => ({
                        ...currentListForFilters,
                        modalityIds: currentListForFilters.modalityIds.filter(
                          (item) => item.value !== itemValue.id
                        )
                      }));
                    }
                  }}
                />
              );
            })}
          {list?.modalityList != null && list?.modalityList?.length == 0 && (
            <div className="no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>
      {roles[0] === USERTYPES.ADMIN  && <div className="filter-section-seperator"></div>}
      {roles[0] === USERTYPES.ADMIN  && <div className="align-filter-section" style={{ width: "15%" }}>
        <span className="filter-section-text">{t("navbar.radiologists")}</span> 
        <SearchBox
          placeholder="Search"
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            filterList(newValue,"radiologistList");
          }}
        />
        <div
          className={`modal-scroll study-list-filter-section ${
            list?.radiologistList?.length == 0 ? "no-result-container" : ""
          }`}
        >
          {list?.radiologistList != null &&
            Array.from(list?.radiologistList).map((itemValue) => {
              return (
                <Checkbox
                  key={itemValue.id}
                  label={itemValue.firstName + " " + itemValue.lastName
                  }
                  name={itemValue.firstName + " " + itemValue.lastName
                  }
                  styles={checkboxFilterStyle}
                  // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                  checked={listForFilter?.radiologistIds?.some(
                    (item) => item.value === itemValue.id
                  )}
                  onChange={(e, data) => {
                    if (data) {
                      console.log("-- check --", [{
                        label: itemValue.firstName + " " + itemValue.lastName,
                        value: itemValue.id
                      }]);
                      setListForFilters({...listForFilter, radiologistIds: [
                        ...listForFilter.radiologistIds,
                        {
                        label: itemValue.firstName + " " + itemValue.lastName,
                        value: itemValue.id
                      }]});
                    } else {
                      console.log("-- uncheck --");
                      setListForFilters((currentListForFilters) => ({
                        ...currentListForFilters,
                        radiologistIds: currentListForFilters?.radiologistIds.filter(
                          (item) => item.value !== itemValue.id
                        )
                      }));
                    }
                  }}
                />
              );
            })}
          {list?.radiologistList != null && list?.radiologistList?.length == 0 && (
            <div className="no-result-message">
              {t("search-message.no-result")}
            </div>
          )}
        </div>
      </div>}
    </div>
  );
};
